"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTransactionListTypeEnum = exports.TransactionsApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class TransactionsApi extends runtime.BaseAPI {
    /**
     * Get all transactions for address in mempool
     * Transactions for address
     */
    async getAddressMempoolTransactionsRaw(requestParameters, initOverrides) {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling getAddressMempoolTransactions.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/address/{address}/mempool`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MempoolTransactionListResponseFromJSON(jsonValue));
    }
    /**
     * Get all transactions for address in mempool
     * Transactions for address
     */
    async getAddressMempoolTransactions(requestParameters, initOverrides) {
        const response = await this.getAddressMempoolTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all recently-broadcast mempool transactions
     * Get dropped mempool transactions
     */
    async getDroppedMempoolTransactionListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx/mempool/dropped`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MempoolTransactionListResponseFromJSON(jsonValue));
    }
    /**
     * Get all recently-broadcast mempool transactions
     * Get dropped mempool transactions
     */
    async getDroppedMempoolTransactionList(requestParameters, initOverrides) {
        const response = await this.getDroppedMempoolTransactionListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all recently-broadcast mempool transactions
     * Get mempool transactions
     */
    async getMempoolTransactionListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.senderAddress !== undefined) {
            queryParameters['sender_address'] = requestParameters.senderAddress;
        }
        if (requestParameters.recipientAddress !== undefined) {
            queryParameters['recipient_address'] = requestParameters.recipientAddress;
        }
        if (requestParameters.address !== undefined) {
            queryParameters['address'] = requestParameters.address;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx/mempool`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MempoolTransactionListResponseFromJSON(jsonValue));
    }
    /**
     * Get all recently-broadcast mempool transactions
     * Get mempool transactions
     */
    async getMempoolTransactionList(requestParameters, initOverrides) {
        const response = await this.getMempoolTransactionListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get raw transaction by ID
     * Get Raw Transaction
     */
    async getRawTransactionByIdRaw(requestParameters, initOverrides) {
        if (requestParameters.txId === null || requestParameters.txId === undefined) {
            throw new runtime.RequiredError('txId', 'Required parameter requestParameters.txId was null or undefined when calling getRawTransactionById.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx/{tx_id}/raw`.replace(`{${"tx_id"}}`, encodeURIComponent(String(requestParameters.txId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetRawTransactionResultFromJSON(jsonValue));
    }
    /**
     * Get raw transaction by ID
     * Get Raw Transaction
     */
    async getRawTransactionById(requestParameters, initOverrides) {
        const response = await this.getRawTransactionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific transaction by ID  `import type { Transaction } from \'@stacks/stacks-blockchain-api-types\';`
     * Get transaction
     */
    async getTransactionByIdRaw(requestParameters, initOverrides) {
        if (requestParameters.txId === null || requestParameters.txId === undefined) {
            throw new runtime.RequiredError('txId', 'Required parameter requestParameters.txId was null or undefined when calling getTransactionById.');
        }
        const queryParameters = {};
        if (requestParameters.eventOffset !== undefined) {
            queryParameters['event_offset'] = requestParameters.eventOffset;
        }
        if (requestParameters.eventLimit !== undefined) {
            queryParameters['event_limit'] = requestParameters.eventLimit;
        }
        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx/{tx_id}`.replace(`{${"tx_id"}}`, encodeURIComponent(String(requestParameters.txId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a specific transaction by ID  `import type { Transaction } from \'@stacks/stacks-blockchain-api-types\';`
     * Get transaction
     */
    async getTransactionById(requestParameters, initOverrides) {
        const response = await this.getTransactionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all recently mined transactions  If using TypeScript, import typings for this response from our types package:  `import type { TransactionResults } from \'@stacks/stacks-blockchain-api-types\';`
     * Get recent transactions
     */
    async getTransactionListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TransactionResultsFromJSON(jsonValue));
    }
    /**
     * Get all recently mined transactions  If using TypeScript, import typings for this response from our types package:  `import type { TransactionResults } from \'@stacks/stacks-blockchain-api-types\';`
     * Get recent transactions
     */
    async getTransactionList(requestParameters, initOverrides) {
        const response = await this.getTransactionListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all transactions in block
     * Transactions in a block
     */
    async getTransactionsByBlockHashRaw(requestParameters, initOverrides) {
        if (requestParameters.blockHash === null || requestParameters.blockHash === undefined) {
            throw new runtime.RequiredError('blockHash', 'Required parameter requestParameters.blockHash was null or undefined when calling getTransactionsByBlockHash.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx/block/{block_hash}`.replace(`{${"block_hash"}}`, encodeURIComponent(String(requestParameters.blockHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TransactionResultsFromJSON(jsonValue));
    }
    /**
     * Get all transactions in block
     * Transactions in a block
     */
    async getTransactionsByBlockHash(requestParameters, initOverrides) {
        const response = await this.getTransactionsByBlockHashRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all transactions in block by height
     * Transactions in a block
     */
    async getTransactionsByBlockHeightRaw(requestParameters, initOverrides) {
        if (requestParameters.height === null || requestParameters.height === undefined) {
            throw new runtime.RequiredError('height', 'Required parameter requestParameters.height was null or undefined when calling getTransactionsByBlockHeight.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tx/block_height/{height}`.replace(`{${"height"}}`, encodeURIComponent(String(requestParameters.height))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TransactionResultsFromJSON(jsonValue));
    }
    /**
     * Get all transactions in block by height
     * Transactions in a block
     */
    async getTransactionsByBlockHeight(requestParameters, initOverrides) {
        const response = await this.getTransactionsByBlockHeightRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Broadcast raw transactions on the network. You can use the [@stacks/transactions](https://github.com/blockstack/stacks.js) project to generate a raw transaction payload.
     * Broadcast raw transaction
     */
    async postCoreNodeTransactionsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/octet-stream';
        const response = await this.request({
            path: `/v2/transactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     * Broadcast raw transactions on the network. You can use the [@stacks/transactions](https://github.com/blockstack/stacks.js) project to generate a raw transaction payload.
     * Broadcast raw transaction
     */
    async postCoreNodeTransactions(requestParameters, initOverrides) {
        const response = await this.postCoreNodeTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.TransactionsApi = TransactionsApi;
/**
    * @export
    * @enum {string}
    */
var GetTransactionListTypeEnum;
(function (GetTransactionListTypeEnum) {
    GetTransactionListTypeEnum["coinbase"] = "coinbase";
    GetTransactionListTypeEnum["token_transfer"] = "token_transfer";
    GetTransactionListTypeEnum["smart_contract"] = "smart_contract";
    GetTransactionListTypeEnum["contract_call"] = "contract_call";
    GetTransactionListTypeEnum["poison_microblock"] = "poison_microblock";
})(GetTransactionListTypeEnum = exports.GetTransactionListTypeEnum || (exports.GetTransactionListTypeEnum = {}));
//# sourceMappingURL=TransactionsApi.js.map